export function initCompanyPrivRadio() {
    const invoice = document.getElementById('invoice');
    const b_nip = document.getElementById('billing_nip_field');
    const b_company = document.getElementById('billing_company_field');
    const s_nip = document.getElementById('shipping_nip_field');
    const s_company = document.getElementById('shipping_company_field');

    function handleRadioClick() {
        if (document.getElementById('private_company_company').checked) {
            invoice.checked = true;
            b_nip.style.display = 'block';
            b_nip.classList.add('validate-required');
            b_company.style.display = 'block';
            b_company.classList.add('validate-required');
            s_nip.style.display = 'block';
            s_nip.classList.add('validate-required');
            s_company.style.display = 'block';
            s_company.classList.add('validate-required');
        } else {
            invoice.checked = false;
            b_nip.style.display = 'none';
            b_nip.classList.remove('validate-required');
            b_nip.classList.remove('woocommerce-validated');
            b_company.style.display = 'none';
            b_company.classList.remove('validate-required');
            b_company.classList.remove('woocommerce-validated');
            s_nip.style.display = 'none';
            s_nip.classList.remove('validate-required');
            s_nip.classList.remove('woocommerce-validated');
            s_company.style.display = 'none';
            s_company.classList.remove('validate-required');
            s_company.classList.remove('woocommerce-validated');
        }
    }

    handleRadioClick();

    const radioButtons = document.querySelectorAll('input[name="private_company"]');
    radioButtons.forEach(radio => {
        radio.addEventListener('click', handleRadioClick);
    });
}